import { useEffect, useState } from "react";

import { updateBusinessSettings } from "../../services/settingsApi";

function BusinessSettings({ settings, reload }) {

    const [formData, setFormData] = useState({
        companyName: "",
        gstNumber: "",
        fssaiNumber: "",
        businessAddress: "",
    });

    useEffect(() => {

        if (settings) {

            setFormData({
                companyName: settings.companyName || "",
                gstNumber: settings.gstNumber || "",
                fssaiNumber: settings.fssaiNumber || "",
                businessAddress: settings.businessAddress || "",
            });

        }

    }, [settings]);

    const handleChange = (e) => {

        setFormData({
            ...formData,
            [e.target.name]: e.target.value,
        });

    };

    const handleSubmit = async (e) => {

        e.preventDefault();

        try {

            await updateBusinessSettings(formData);

            alert("Business settings updated successfully.");

            reload();

        } catch (error) {

            console.error(error);

            alert("Failed to update business settings.");

        }

    };

    return (

        <form
            className="settings-form"
            onSubmit={handleSubmit}
        >

            <div className="settings-card">

                <h2>Business Settings</h2>

                <div className="settings-grid">

                    <div className="form-group">

                        <label>Company Name</label>

                        <input
                            type="text"
                            name="companyName"
                            value={formData.companyName}
                            onChange={handleChange}
                        />

                    </div>

                    <div className="form-group">

                        <label>GST Number</label>

                        <input
                            type="text"
                            name="gstNumber"
                            value={formData.gstNumber}
                            onChange={handleChange}
                        />

                    </div>

                    <div className="form-group">

                        <label>FSSAI Number</label>

                        <input
                            type="text"
                            name="fssaiNumber"
                            value={formData.fssaiNumber}
                            onChange={handleChange}
                        />

                    </div>

                    <div className="form-group">

                        <label>Business Address</label>

                        <textarea
                            name="businessAddress"
                            rows="4"
                            value={formData.businessAddress}
                            onChange={handleChange}
                        />

                    </div>

                </div>

                <button
                    type="submit"
                    className="save-btn"
                >
                    Save Business Settings
                </button>

            </div>

        </form>

    );

}

export default BusinessSettings;